import TabItems from "./TabItems";

const Tab = ({ selected, setSelected, items }) => {
  return (
    <ul className="flex flex-nowrap overflow-x-auto w-full m-0 bg-gray-200 dark:border-gray-500 dark:bg-gray-500 justify-start">
      {items.map((item, index) => (
        <TabItems
          item={item}
          key={item.id ?? index}
          selected={String(selected)}
          setSelected={(id) => setSelected(String(id))}
        />
      ))}
    </ul>
  );
};

export default Tab;
